import React from 'react'


export const Select = ({enums, style = {}, multiple = false, tabIndex, disabled=false, label, changeHandler, value, className = ''}) => {

  return (!label ?
    (<select style={style} size={1} multiple={multiple} tabIndex={tabIndex} className={className} disabled={disabled} value={value} onChange={changeHandler} >
        {enums.map(en => <option className="dark-theme-bg0" key={en._id} value={en._id}>{en.name || en.fullname}</option>)}
    </select>) :
    <label style={style} className='input__label'>{label}
      <select size={1} multiple={multiple} tabIndex={tabIndex} className={className} disabled={disabled} value={value} onChange={changeHandler} >
        {enums.map(en => <option className="dark-theme-bg0" key={en._id} value={en._id}>{en.name || en.fullname}</option>)}
    </select>
    </label>
  )
}
